import React, { useState } from 'react';
import {
    Box,
    Popover,
    Typography,
    Avatar,
    Button,
    Divider
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LogoutIcon from '@mui/icons-material/Logout';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../store/slices/authSlice';
import { useNavigate } from 'react-router-dom';

const UserProfilePopover = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const userDetails = useSelector((state) => state.user.userDetails);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        dispatch(logout());
        navigate('/login');
    };

    const open = Boolean(anchorEl);

    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box
                onClick={handleClick}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    cursor: 'pointer',
                }}
            >
                <Avatar
                    sx={{
                        width: 40,
                        height: 40,
                        bgcolor: '#00FF85',
                        color: '#000',
                        border: '2px solid #b3ffd8',
                        boxShadow: '0 0 10px 1px #b3ffd8',
                    }}
                >
                    <AccountCircleIcon />
                </Avatar>
                <p className='header-profile-btn'>Profile</p>
                <KeyboardArrowDownIcon
                    sx={{
                        color: '#00FF85',
                        transition: 'transform 0.2s ease',
                        transform: open ? 'rotate(180deg)' : 'rotate(0deg)'
                    }}
                />
            </Box>

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                PaperProps={{
                    sx: {
                        backgroundColor: 'rgba(14, 22, 27, 0.95)',
                        color: '#fff',
                        minWidth: 300,
                        maxHeight: 600,
                        overflow: 'auto',
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                        borderRadius: '12px',
                    }
                }}
            >
                <Box sx={{ p: 3 }}>
                    {/* Profile Section */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                        <Avatar
                            sx={{
                                width: 60,
                                height: 60,
                                bgcolor: '#00FF85',
                                color: '#000',
                                border: '2px solid #b3ffd8',
                            }}
                        >
                            <AccountCircleIcon sx={{ fontSize: 40 }} />
                        </Avatar>
                        <Box>
                            <Typography variant="h6" sx={{ color: '#fff' }}>
                                {userDetails?.name || 'User'}
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#9B9C9E' }}>
                                {userDetails?.email || 'No email'}
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#9B9C9E' }}>
                                {userDetails?.tenantId}
                            </Typography>
                        </Box>
                    </Box>

                    <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.1)', mb: 3 }} />
                    {/* Logout Button */}
                    <Button
                        fullWidth
                        variant="outlined"
                        startIcon={<LogoutIcon />}
                        onClick={handleLogout}
                        sx={{
                            color: '#FF4C4C',
                            borderColor: '#FF4C4C',
                            '&:hover': {
                                borderColor: '#FF4C4C',
                                backgroundColor: 'rgba(255, 76, 76, 0.1)',
                            },
                        }}
                    >
                        Logout
                    </Button>
                </Box>
            </Popover>
        </Box>
    );
};

export default UserProfilePopover; 